import { dateTimeAgo } from 'src/utils/datetime-utils'

import type { IDeviceInfo, TLocationSettingsType, TMotionActivityType } from '../../../../types/tracking'
import { DeviceStatusSection } from './device-status-section'
import { DeviceHeader, DeviceInfoSection } from './shared'
import { TrackingStatusSection } from './tracking-status-section'
import { getMotionActivityWithEmoji } from './utils'

interface ActiveDeviceViewProps {
  device: IDeviceInfo | null
  isTrackingOn?: boolean
  isLoggedIn?: boolean
  lastMotionActivity: TMotionActivityType | null
  lastSeen: string | null
  lastTrackingStoppedAt: string | null
  locationSettings: TLocationSettingsType | null
  hasSentMockLocations: boolean
  isShipmentOwner: boolean
}

export const ActiveDeviceView = ({
  device,
  isTrackingOn,
  isLoggedIn,
  lastMotionActivity,
  lastSeen,
  lastTrackingStoppedAt,
  locationSettings,
  hasSentMockLocations,
  isShipmentOwner
}: ActiveDeviceViewProps) => {
  const motionActivity = getMotionActivityWithEmoji(lastMotionActivity)
  const formattedLastSeen = lastSeen ? dateTimeAgo(lastSeen) : null

  return (
    <>
      <DeviceHeader device={device} />
      <DeviceInfoSection device={device} motionActivity={motionActivity} formattedLastSeen={formattedLastSeen} />
      <TrackingStatusSection
        isTrackingOn={isTrackingOn}
        isLoggedIn={isLoggedIn}
        lastTrackingStoppedAt={lastTrackingStoppedAt}
      />
      <DeviceStatusSection
        device={device}
        locationSettings={locationSettings}
        hasSentMockLocations={hasSentMockLocations}
        isShipmentOwner={isShipmentOwner}
      />
    </>
  )
}
